module.exports = __webpack_public_path__ + "img/symbol_5.06194fb4.png";